import { FC } from 'react';

import AgencyAdminAccountPage from '@service/bugo/page/AgencyAdminAccountPage';
import AgencyAdminBugoBrandAssetManagePage from '@service/bugo/page/AgencyAdminBugoBrandAssetManagePage';
import { AgencyAdminBugoStatNewPage } from '@service/bugo/page/AgencyAdminBugoStatNewPage';
import AgencyAdminFlowerStatPage from '@service/bugo/page/AgencyAdminFlowerStatPage';
import AgencyAdminWorkerPage from '@service/bugo/page/AgencyAdminWorkerPage';
import AgencyAdminWorkerStatPage from '@service/bugo/page/AgencyAdminWorkerStatPage';
import CourtesyAssetContentManagePage from '@service/bugo/page/CourtesyAssetContentManagePage';
import { AgencyAdminGiftDeliveryManagementPage } from '@service/giftSeller/page/AgencyAdminGiftDeliveryManagementPage';
import { AgencyAdminGiftEventLogPage } from '@service/giftSeller/page/AgencyAdminGiftEventLogPage';
import { Navigate, Route, Routes } from 'react-router-dom';

import { BugoStatRouter } from './BugoStatRouter';

const BugoBrandIdRouter: FC = () => {
  return (
    <Routes>
      <Route path="flower-stat" element={<AgencyAdminFlowerStatPage />} />
      <Route path="bugo-stat" element={<BugoStatRouter />} />
      <Route path="bugo-stat-new" element={<AgencyAdminBugoStatNewPage />} />
      <Route path="agency-worker-stat" element={<AgencyAdminWorkerStatPage />} />
      <Route path="account" element={<AgencyAdminAccountPage />} />
      <Route path="gift-event-log" element={<AgencyAdminGiftEventLogPage />} />
      <Route
        path="gift-delivery-management"
        element={<AgencyAdminGiftDeliveryManagementPage />}
      />
      <Route path="agency-workers" element={<AgencyAdminWorkerPage />} />
      <Route path="asset">
        <Route path="" element={<AgencyAdminBugoBrandAssetManagePage />} />
        <Route path="courtesy" element={<CourtesyAssetContentManagePage />}></Route>
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default BugoBrandIdRouter;
